export const ClickableCard = ({ active, onClick, testid, className = '', children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={!!active}
    data-testid={testid}
    className={`block text-left w-full rounded-lg cursor-pointer transition-[box-shadow,transform] duration-150 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 ${active ? 'ring-2 ring-slate-900 ring-offset-1 shadow-md' : ''} ${className}`}
  >
    {children}
  </button>
);

export const ActiveFilterChip = ({ label, onClear, testid = 'active-card-filter' }) => (
  <div className="flex items-center gap-2 text-sm" data-testid={testid}>
    <span className="text-slate-500">Showing:</span>
    <span className="inline-flex items-center gap-1.5 bg-slate-900 text-white rounded-full pl-3 pr-1 py-0.5 text-xs font-medium">
      {label}
      <button type="button" onClick={onClear} className="rounded-full hover:bg-slate-700 px-1.5" aria-label="Clear filter" data-testid={`${testid}-clear`}>×</button>
    </span>
  </div>
);
